<template>
  <div>
    <div class="new_page_tabpc" style="padding-left: 13%; flex: 1;">
      <router-link to="/sport/lsport/prematch" ><span>엘스포츠 유럽형</span></router-link>
      <router-link to="/sport/prematch"><span>벳컨 유럽형</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-프리매치' }" class="cho"><span>오즈메트릭스</span></router-link>
    </div>
    <div style="display: flex;">
      <SideBar/>
      <div style="flex: 1;">
        <div class="sports-table-container">
          <GameDetail />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/OddsMatrix/SideBar.vue'
import GameDetail from '@/components/OddsMatrix/GameDetail.vue'

import MSG from '../../../contants/msg'

import {mapState, mapActions } from "vuex";

export default {
  name: "Sports",
  components: {
    SideBar,
    GameDetail,
  },
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
  },
  mounted: function () {
    // 웹소켓 연결
    this.connectSocket();
  },
  beforeDestroy () {
    this.disconnectSocket();
  },
  methods: {
    ...mapActions('oddsmatrix', ['fetchEvents', 'connectSocket', 'disconnectSocket']),
    addCart: function (bets, folders, game) {
      if (this.user){
        const config = this.user.members_detail_setting;
        if (!config.베팅권한.유럽형.active) {
          return alert(MSG.authorization);
        }
      } else {
        return alert(MSG.isNotLogin);
      }

      const cartItem = {
        gameId: game.id,
        gameSeq: game.seq,
        betsSeq: bets.seq,
        betsStatus: bets.status,
        betsId: bets.id,
        betsName: bets.name,
        betsUpdated: false,
        betsPrevOdds: bets.price,
        sportsId: game.sportSeq,
        foldersSeq: folders.seq,
        foldersType: folders.type,
        foldersStatus: folders.status,
        odds: bets.price,
        line: bets.line ? bets.line : null,
        leagueId: game.leagueId,
        leagueNameKr: game.league.nameKr,
        leagueNameEn: game.league.nameEn,
        leagueNameIcon: game.league.icon,
        sportNameKr: game.sport.nameKr,
        sportNameEn: game.sport.nameEn,
        sportNameIcon: game.sport.icon,
        homeNameKr: game.homeTeam.nameKr,
        homeNameEn: game.homeTeam.nameEn,
        awayNameKr: game.awayTeam.nameKr,
        awayNameEn: game.awayTeam.nameEn,
        marketNameKr: folders.market.nameKr,
        marketNameEn: folders.market.nameEn,
        marketsId: folders.marketId,
        startTime: game.startTime,
        odds1: folders.line,
        odds2: null,
        odds3: null,
        betType: '프리매치(엘스포츠-유럽형)',
        detailType: null,
        currentPeriod: game.currentPeriod,
        currentTime: game.currentTime,
        homeScore: game.homeResult,
        awayScore: game.awayResult,
        penalty: null,
        maxAmount: game.league?.maxAmount
      };
      console.log('카트아이템', cartItem)
      cartItem.marketNameKr = folders.market.nameKr?.replace('{sw}', game.sport.periodName);
      cartItem.marketNameEn = folders.market.nameEn?.replace('{sw}', game.sport.periodName);

      if (game.sport.periodName === '반전') {
        cartItem.marketNameKr = folders.market.nameKr?.replace('1{sw}', '전반전')
        cartItem.marketNameEn = folders.market.nameEn?.replace('2{sw}', '후반전')
      }
      this.$store.dispatch('ADD_LSPORT_EUROPEAN_CART_ITEM', cartItem)
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */

{
  opacity: 0
}

.categorys::-webkit-scrollbar{
  display:none;
}

.sports-table-container {
  width: 100%;
}

@media (min-width: 1000px) {
  .sports-table-container {
    width: 75% !important;
  }
}
</style>
